<template>
	<div class="menuBody">
		<!-- <RoomManTree @RoomManTree="getMsgFormSon" /> -->
		<div class="menuTool" style="width:100%;">
			<el-form :inline="true" label-position="right" label-width="100px" :model="query">
				<el-form-item label="表号">
					<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
				</el-form-item>
				<el-form-item label="订单号">
					<el-input size="small" v-model="query.sn" placeholder="请输入订单号" clearable></el-input>
				</el-form-item>
				<el-form-item label="房间号">
					<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
				</el-form-item>
				<el-form-item label="业主名">
					<el-input size="small" v-model="query.roomCusName" placeholder="请输入业主名" clearable></el-input>
				</el-form-item>
				<el-form-item label="仪表类型">
					<el-select size="small" v-model="query.meterType" placeholder="仪表类型" clearable>
						<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="收费方式">
					<el-select size="small" v-model="formData.payMode" placeholder="收费方式" clearable>
						<el-option v-for="item in payMode" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="退款状态">
					<el-select size="small" v-model="query.refundStatus" placeholder="退款状态" clearable>
						<el-option v-for="item in refundStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否智能表">
					<el-select size="small" v-model="query.autoFlag" placeholder="是否智能表" clearable>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="缴费时间">
					<el-date-picker
						v-model="query.dataRange"
						type="daterange"
						align="right"
						size="small"
						style="width: 410px"
						value-format="yyyy-MM-dd"
						unlink-panels
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:picker-options="pickerOptions"
					>
					</el-date-picker>
				</el-form-item>
			</el-form>
			<div class="button-tool">
				<el-button size="small" type="primary" @click="doSearch">查询</el-button>
				<el-button size="small" type="primary" @click="doExport">导出</el-button>
			</div>
			<el-table :data="tableData" row-key="id" border :stripe="true">
				<el-table-column width="200" prop="sn" label="订单号"></el-table-column>
				<el-table-column width="200" prop="payMeterNo" label="表号"></el-table-column>
				<el-table-column width="200" prop="actualNo" label="实际表号"></el-table-column>
				<el-table-column width="160" prop="mainNo" label="主表号"></el-table-column>
				<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
				<el-table-column width="160" prop="projectName" label="项目小区"></el-table-column>
				<el-table-column width="200" prop="floorName" label="楼栋"></el-table-column>
				<el-table-column width="100" prop="roomName" label="房间号"></el-table-column>
				<el-table-column width="150" prop="roomCusName" label="业主名"></el-table-column>
				<el-table-column width="150" prop="invoiceTime" label="开票时间"></el-table-column>
				<el-table-column width="150" prop="payAmount" label="缴费金额">
					<template slot-scope="scope"> {{ scope.row.payAmount }}元 </template>
				</el-table-column>
				<el-table-column width="150" prop="payTypeStr" label="支付方式"></el-table-column>
				<el-table-column width="150" prop="payTime" label="支付时间"></el-table-column>
				<el-table-column width="150" prop="chargeStatusStr" label="充值状态"></el-table-column>
				<el-table-column width="150" prop="refundStatusStr" label="退款状态"></el-table-column>
				<el-table-column width="150" prop="remarks" label="备注"></el-table-column>
				<el-table-column width="200" fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button @click="doOpenInvoicePage(scope.row)" type="text" size="small">凭证</el-button>
						<el-button @click="doOpenEdit(scope.row)" type="text" size="small">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="pagination.page"
				:page-sizes="[10, 20, 40, 50]"
				:page-size="pagination.size"
				layout="total, sizes, prev, pager, next"
				:total="pagination.total"
				style="float: right; margin: 10px 0px;"
			>
			</el-pagination>

			<el-dialog :title="invoiceDlg.title" center :show-close="false" :visible="invoiceDlg.visible" v-if="invoiceDlg.visible" :destroy-on-close="true"> </el-dialog>

			<el-dialog :title="editDlg.title" width="600px" center :visible.sync="editDlg.visible" v-if="editDlg.visible" :destroy-on-close="true">
				<el-form :inline="true" label-position="right" label-width="100px" :model="editDlg.formData">
					<el-form-item label="实际表号">
						<el-input size="small" v-model="editDlg.formData.actualNo" placeholder="请输入实际表号" clearable></el-input>
					</el-form-item>
					<el-form-item label="电损">
						<el-input size="small" v-model="editDlg.formData.loss" placeholder="请输入电损" clearable></el-input>
					</el-form-item>
					<el-form-item label="仪表类型">
						<el-select size="small" v-model="editDlg.formData.meterType" placeholder="仪表类型" clearable>
							<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否公共">
						<el-select size="small" v-model="editDlg.formData.isPublic" placeholder="是否公共" clearable>
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属房产">
						<!-- <el-tree
                    :data="roomTreeData"
                    :props="defaultProps"
                    v-model="editDlg.formData.roomId"
                    accordion
                    placeholder="请输入房间号" 
                    clearable
                    @node-click="handleNodeClick">
                    </el-tree> -->
						<el-input size="small" v-model="editDlg.formData.roomId" placeholder="请输入房间号" clearable></el-input>
					</el-form-item>
					<el-form-item label="是否虚拟表">
						<el-select size="small" v-model="editDlg.formData.dummyFlag" placeholder="是否虚拟表" clearable>
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="备注">
						<el-input
							size="small"
							v-model="editDlg.formData.remarks"
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入备注"
							clearable
						></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="doSaveEditBasicInfo">确 定</el-button>
					<el-button @click="editDlg.visible = false">取 消</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import { useStatus, options, meterType, payMode, refundStatus } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import _ from "lodash";
import { get, post, put } from "@/assets/common/request";

export default {
	name: "PaidTable",
	components: {},
	mixins: [mixin],
	data() {
		return {
			useStatus,
			options,
			meterType,
			payMode,
			refundStatus,
			queryListUrl: "/meter/web/order/listPage",
			invoiceDlg: {
				title: "凭证",
				visible: false,
			},
			editDlg: {
				title: "",
				visible: false,
				formData: {},
			},
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		doExport() {
			const title = "已支付订单数据";
			const url = "meter/web/order/export";
			this._export(title, url);
		},
		doOpenInvoicePage() {
			this.invoiceDlg.visible = true;
		},
		doOpenEdit(rowData) {
			const url = `/meter/web/basic/${rowData.id}`;
			get(url).then(({ data }) => {
				const formData = _.pick(data, ["id", "actualNo", "loss", "meterType", "isPublic", "roomId", "dummyFlag", "remarks"]);
				this.editDlg = {
					title: `修改 表号${data.actualNo}`,
					visible: true,
					formData: formData,
				};
			});
		},
		doSaveEditBasicInfo() {
			const formData = _.pick(this.editDlg.formData, ["id", "actualNo", "loss", "meterType", "isPublic", "roomId", "dummyFlag", "remarks"]);
			const url = `/meter/web/basic/${formData.id}`;
			put(url, formData).then((data) => {
				this.doSearch();
				this.editDlg.visible = false;
			});
		},
	},
	mounted() {
		this.doSearch();
	},
};
</script>
